import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <img src="/logo-icon.png" alt="宽思智能" className="w-8 h-8 rounded-lg" />
              <span className="text-xl font-bold" style={{ fontFamily: '\'Noto Sans SC\', sans-serif' }}>宽思智能</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-8" style={{ fontFamily: '\'Noto Sans SC\', sans-serif' }}>
              帮助企业完成 AI 时代的软件生产方式重构。<br />
              把过去想做但做不了的事情，变成现在就能做。
            </p>
            <div className="flex items-center gap-4">
              <img src="/logos/qrcode_with_logo.png" alt="宽思智能公众号" className="w-24 h-24 rounded-lg" />
              <div>
                <p className="text-xs text-white/40 mb-1">微信公众号</p>
                <p className="text-sm text-white/70">宽思智能</p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-white/40 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>导航</h4>
            <div className="flex flex-col gap-3">
              {[
                { label: '首页', path: '/' },
                { label: 'AI 赋能培训', path: '/training' },
                { label: '服务', path: '/services' },
                { label: '案例', path: '/cases' },
                { label: '关于我们', path: '/about' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                  style={{ fontFamily: '\'Noto Sans SC\', sans-serif' }}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-white/40 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>联系我们</h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#F97316] text-sm" />
                </div>
                <span className="text-sm text-white/60 leading-relaxed" style={{ fontFamily: '\'Noto Sans SC\', sans-serif' }}>
                  北京市朝阳区东四环中路82号<br />
                  3座19层
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#F97316] text-sm" />
                </div>
                <span className="text-sm text-white/60" style={{ fontFamily: 'Inter, sans-serif' }}>service@broadmind.cn</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40" style={{ fontFamily: '\'Noto Sans SC\', sans-serif' }}>
            © 2026 宽思智能. 保留所有权利
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="nofollow noopener"
              className="text-xs text-white/40 hover:text-white/70 transition-colors"
              style={{ fontFamily: '\'Noto Sans SC\', sans-serif' }}
            >
              京ICP备2026021347号
            </a>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502060632"
              target="_blank"
              rel="nofollow noopener"
              className="flex items-center gap-1.5 text-xs text-white/40 hover:text-white/70 transition-colors"
              style={{ fontFamily: '\'Noto Sans SC\', sans-serif' }}
            >
              <img src="/logos/police-badge.png" alt="" className="w-3.5 h-3.5" />
              京公网安备11010502060632号
            </a>
            {['隐私政策', '服务条款', '网站地图'].map((item) => (
              <a
                key={item}
                href="#"
                className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer"
                style={{ fontFamily: '\'Noto Sans SC\', sans-serif' }}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
